import { WebinarHelper } from '..';

export const useWebinar = () => {
	let webinarHelper = new WebinarHelper();
	return {
		webinarHelper,
		activeWebinar: webinarHelper.active()
	};
};
